import { pagePath } from './routes'
import type { Locale } from './types'

export interface TransportSeoDocument {
  id: string
  locale: Locale
  path: string
  alternatePath: string
  title: string
  description: string
  index: boolean
}

const metadata = {
  ar: {
    title: 'خريطة خطوط باصات سوريا | Syria Bus Transport',
    description: 'اختر المنطقة وشبكة النقل واعرض الخطوط والاتجاهات والمواقف مباشرة على خريطة واحدة.',
  },
  en: {
    title: 'Syria Bus Lines Map | Syria Bus Transport',
    description: 'Choose an area and transport network to view matching bus lines, directions, and stops on one map.',
  },
} as const

export const transportSeoManifest: TransportSeoDocument[] = (['ar', 'en'] as const)
  .map((locale) => {
    const opposite: Locale = locale === 'ar' ? 'en' : 'ar'
    return {
      id: `${locale}:map`,
      locale,
      path: pagePath(locale, 'home'),
      alternatePath: pagePath(opposite, 'home'),
      title: metadata[locale].title,
      description: metadata[locale].description,
      index: true,
    }
  })

export function getStaticSeo(pathname: string) {
  const normalized = pathname === '/' || pathname.endsWith('/')
    ? pathname
    : `${pathname}/`
  return transportSeoManifest.find((document) => document.path === normalized)
}
